var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstrument0(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 563.53 563.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2e1b16;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "drum"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M513,310c-13,1,35-116-65-220,0,0,12-7,10-15,0,0-7-15-32-1,0,0-34-30-108-26,0,0-90,3-122,20,0,0-3.89-13-12.45-10,0,0-7.55,5-4.55,18,0,0-82,64-102,202,0,0-16-2-15,7,0,0,4,8,15,11,0,0-6,75,37,151,0,0-11,11-4,18s16-3,16-3,44,66,209,62a83.53,83.53,0,0,0,29-4,48,48,0,0,0,23,2s5-2,4-10c0,0,94.7-26,118.85-183.5L512,323s7,2,14-5C526,318,526,309,513,310Zm-79-2c-1,54-51,165-112,179,0,0-93,36-185-35,0,0,7-15-10-12,0,0-34-56-37-144,0,0,14-8,0-18,0,0,6-89,94-188,0,0,10,6,17-9,0,0,45-18,118-17,0,0,30-4,60,24C379,88,446,154,434,308Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstrument0);
export default __webpack_public_path__ + "static/media/instrument-0.b1796a66fc65f39bedc0d77aeffadbb6.svg";
export { ForwardRef as ReactComponent };